<div class="card-container h-100"
  style="border: 1px solid #e2e8f0; border-radius: 0.5rem; overflow: hidden; background: #ffffff;">
  <div class="card-header py-2 px-3 text-white font-weight-bold"
    style="background: var(--theme-primary, #123c53); font-size: 0.8125rem; text-transform: uppercase; letter-spacing: 0.5px;">
    <i class="fas fa-comments mr-1"></i> Personal Discussion (PD) Records
  </div>

  <div class="p-3" *ngIf="!PDQuestionData || PDQuestionData.length === 0">
    <div class="text-center p-3 bg-light rounded text-muted font-size-12">
      <i class="fas fa-info-circle mr-1"></i> No PD Information Available!
    </div>
  </div>

  <div class="cnt-data p-3" *ngIf="PDQuestionData && PDQuestionData.length > 0">
    <!-- PD Meta summary box -->
    <div class="p-2 mb-3 rounded border bg-light" style="font-size: 0.75rem;" *ngIf="PDQuestionData[0]">
      <div class="d-flex justify-content-between mb-1">
        <span><strong>Done By:</strong> {{ PDQuestionData[0].TVR_Done_By || '-' }}</span>
        <span><strong>Done On:</strong> {{ PDQuestionData[0].PD_DoneOn || '-' }}</span>
      </div>
      <div *ngIf="PDQuestionData[0].PD_Remark" class="text-muted">
        <strong>Remark:</strong> {{ PDQuestionData[0].PD_Remark }}
      </div>
    </div>

    <!-- Q&A List -->
    <div class="cont" style="display: flex; flex-direction: column; gap: 0.5rem;">
      <div *ngFor="let item of PDQuestionData">
        <div class="p-2.5 rounded border" style="background: #fafbfc; border-color: #e2e8f0 !important;">
          <div class="font-weight-bold text-dark mb-1" style="font-size: 0.8125rem;">
            Q: {{ item.Question }}
          </div>
          <div class="text-muted small mb-1" *ngIf="item.Question_Hindi">
            {{ item.Question_Hindi }}
          </div>
          <div class="d-flex align-items-start mt-1">
            <span class="badge badge-info mr-2 mt-1">Ans</span>
            <span class="font-weight-bold text-primary" style="font-size: 0.8125rem; white-space: pre-wrap; word-break: break-word; flex: 1;">
              {{ item.Answer || 'N/A' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>